export default __webpack_public_path__ + "static/media/CU.5cb60d72.svg";